// PRE RMA — Module Communication et sensibilisation (Tableau 3).
// Source : SAISIE_TAB3_COMMUNICATION.html.

export const PROGRAMMES_COMMUNICATION = ['PEV', 'SIMR', 'MSR', 'NUTRITION', 'PALUDISME', 'TUBERCULOSE'] as const;

export interface SeanceCommunication { programme: string; theme: string; hommes: number | null; femmes: number | null }

const n = (x: unknown) => { const v = typeof x === 'number' ? x : parseInt(String(x ?? ''), 10); return Number.isFinite(v) && v > 0 ? v : 0; };
export const totalSeance = (s: SeanceCommunication) => n(s.hommes) + n(s.femmes);

export function validerSeanceCommunication(s: Partial<SeanceCommunication>): { ok: boolean; erreurs: string[]; alertes: string[] } {
  const erreurs: string[] = [], alertes: string[] = [];
  const t = n(s.hommes) + n(s.femmes);
  if (t > 0 && !(s.programme ?? '').trim()) erreurs.push('Indiquez le programme.');
  else if (t > 0 && !(s.theme ?? '').trim()) erreurs.push('Indiquez le thème de la séance.');
  else if (t === 0 && ((s.programme ?? '').trim() || (s.theme ?? '').trim())) alertes.push('Aucun participant saisi pour cette séance.');
  else if (t > 1000) alertes.push('Effectif très élevé (>1000) : à vérifier.');
  for (const k of ['hommes', 'femmes'] as const) {
    const v = s[k];
    if (v !== null && v !== undefined && (!Number.isInteger(v) || v < 0 || v > 999_999)) erreurs.push(`${k} : entier positif attendu.`);
  }
  if ((s.theme ?? '').length > 200) erreurs.push('Thème : 200 caractères maximum.');
  if ((s.programme ?? '').length > 60) erreurs.push('Programme : 60 caractères maximum.');
  return { ok: erreurs.length === 0, erreurs, alertes };
}

export function totauxCommunication(seances: SeanceCommunication[]) {
  const hommes = seances.reduce((a, s) => a + n(s.hommes), 0);
  const femmes = seances.reduce((a, s) => a + n(s.femmes), 0);
  const parProgramme: Record<string, { seances: number; hommes: number; femmes: number; total: number }> = {};
  for (const s of seances) {
    if (!s.programme) continue;
    const p = (parProgramme[s.programme] ??= { seances: 0, hommes: 0, femmes: 0, total: 0 });
    p.seances += 1; p.hommes += n(s.hommes); p.femmes += n(s.femmes); p.total += totalSeance(s);
  }
  return { hommes, femmes, total: hommes + femmes, parProgramme };
}
